<template>
    <option :value="null"> --- <slot>Bitte auswählen</slot></option>
</template>
